module.exports = __webpack_public_path__ + "img/symbol_8.6abcfab3.png";